export default __webpack_public_path__ + "static/media/fondo.c27fe63c.jpg";